
import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import Layout from '@/components/layout/Layout';
import BeginnerHero from '@/components/beginners/BeginnerHero';
import BeginnerBenefits from '@/components/beginners/BeginnerBenefits';
import BeginnerJourney from '@/components/beginners/BeginnerJourney';
import BeginnerTestimonials from '@/components/beginners/BeginnerTestimonials';
import BeginnerFAQ from '@/components/beginners/BeginnerFAQ';
import { preloadCriticalImages } from '@/utils/optimizeImages';
import AboutCTA from '@/components/about/AboutCTA';

const BeginnerPianoLessons = () => {
  // Preload critical images for performance
  useEffect(() => {
    preloadCriticalImages([
      '/lovable-uploads/69c22a01-1204-49e5-9098-5b2d417301e8.png',
      '/lovable-uploads/c3099eea-1cdc-462a-9e3c-85f757436352.png'
    ]);
  }, []);

  return (
    <Layout>
      <div id="top"></div>
      <Helmet>
        <title>Klaverundervisning for begyndere | Kom godt i gang med at spille klaver</title>
        <meta name="description" content="Særligt tilrettelagt klaverundervisning for begyndere med professionel pianist. Lær at spille klaver fra grunden med sjove og effektive metoder. Book din gratis prøvetime i dag!" />
        <link rel="canonical" href="https://pianoundervisning.dk/klaverundervisning-begyndere" />
        <meta property="og:title" content="Klaverundervisning for begyndere | Kom godt i gang med at spille klaver" />
        <meta property="og:description" content="Særligt tilrettelagt klaverundervisning for begyndere med professionel pianist. Lær at spille klaver fra grunden med sjove og effektive metoder." />
        <meta property="og:url" content="https://pianoundervisning.dk/klaverundervisning-begyndere" />
        <meta property="og:type" content="website" />
        <meta name="keywords" content="klaverundervisning begyndere, lær at spille klaver, klaver for nybegyndere, klaverlektioner for begyndere, nybegynder klaverundervisning" />
      </Helmet>

      <BeginnerHero />
      <BeginnerBenefits />
      <BeginnerJourney />
      <BeginnerTestimonials />
      <BeginnerFAQ />
      <AboutCTA 
        title="Start din klaverrejse i dag"
        description="Tag det første skridt mod at mestre klaveret. Book en gratis prøvetime og oplev, hvor sjovt og tilfredsstillende det er at lære at spille."
        primaryButtonText="Book gratis prøvetime"
        secondaryButtonText="Se alle undervisningstilbud"
      />
    </Layout>
  );
};

export default BeginnerPianoLessons;
